import styled from 'styled-components'

const HorseCareerWinRatesStyled = styled.div`
  .infor-horse {
    .carrer {
      display: block;
      .color-career {
        margin-bottom: 6px;
        font-size: 24px;
        line-height: 14px;
        color: #4ef076;
      }

      .carrer-detail {
        font-size: 18px;
        .total {
          color: #fff566;
        }
      }
    }

    .win-rates {
      display: block;
      .color-win-rates {
        margin-bottom: 6px;
        font-size: 24px;
        line-height: 14px;
        color: #4ef076;
      }
      .win-rates-count {
        font-size: 18px;
      }
    }

    .class {
      display: block;
      .color-class {
        margin-bottom: 6px;
        font-size: 24px;
        line-height: 14px;
        color: #4ef076;
      }
    }
  }
`
export default HorseCareerWinRatesStyled
